import { DeviceProfile, getDeviceProfile } from "@novorender/api";

import { RecursivePartial } from "types/misc";
import { mergeRecursive } from "utils/misc";

export type StoredDeviceProfile = DeviceProfile & { debugProfile: true; autofreezeEnabled?: boolean };

/**
 * Merge a (possibly partial) debug JSON onto a full engine profile so View.create
 * always receives required fields such as `quirks.adreno600`.
 */
export function parseDebugDeviceProfile(json: string): StoredDeviceProfile {
    const parsed = JSON.parse(json) as RecursivePartial<DeviceProfile> & { autofreezeEnabled?: boolean };
    const tierRaw = typeof parsed.tier === "number" ? parsed.tier : 0;
    const tier = (tierRaw >= 0 && tierRaw <= 3 ? tierRaw : 0) as DeviceProfile["tier"];
    return {
        ...mergeRecursive(getDeviceProfile(tier), parsed),
        debugProfile: true,
    };
}

export function getStoredDeviceProfile(): StoredDeviceProfile | undefined {
    try {
        const debugProfile =
            new URLSearchParams(window.location.search).get("debugDeviceProfile") ?? localStorage["debugDeviceProfile"];

        if (debugProfile) {
            return parseDebugDeviceProfile(debugProfile);
        }
    } catch (e) {
        console.warn(e);
    }
}
